import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import React from "react";
import { useNavigate } from "react-router-dom";

import useIsMobile from "../../helpers/isMobile";
import { useUserContext } from "../infrastructure/UserContext";

import { AccountDropdown } from "./AccountDropdown";

export const AccountButton = () => {
    const { isMobile } = useIsMobile();
    const navigate = useNavigate();
    const user = useUserContext();

    const button = (
        <button
            type="button"
            className="btn p-0 d-flex align-items-center gap-3"
            onClick={() => navigate("/cuenta")}
            aria-haspopup={!isMobile ? "menu" : undefined}
            aria-label="Cuenta"
            title="Cuenta"
        >
            {!isMobile && (
                <div className="d-flex flex-column text-end" style={{ color: "#787878" }}>
                    <small>Cliente</small>
                    <small style={{ color: "#939393", fontWeight: 600 }}>
                        {user?.code}
                    </small>
                </div>
            )}

            <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: 42, height: 42, backgroundColor: "#eaeaea" }}
            >
                <Person2OutlinedIcon fontSize="large" className="text-primary" />
            </div>
        </button>
    );


    if (!isMobile) return <AccountDropdown>{button}</AccountDropdown>;

    return button;
};
